/**
 * GA4 Navigation Events - hoverOnNavigationBar, SysNavigationBarExpanded, clickOnNavigationBar
 * Uses direct listeners on nav elements instead of document for better performance.
 */

(function () {
  const gtag = window.trovelle?.ga4?.gtag;
  const measurementId = window.trovelle?.ga4?.measurementId;
  if (!gtag || !measurementId) return;

  function getPageParams() {
    const route = window.trovelle?.ga4?.route?.getRoute?.();
    const pt = route?.pageType || 'page';
    const pageType = pt.charAt(0).toUpperCase() + pt.slice(1);
    return {
      page_location: window.location.href,
      page_title: document.title || '',
      referrer: document.referrer || '',
      page_type: pageType,
    };
  }

  function handleClick(link, nav) {
    const route = window.trovelle?.ga4?.route?.getRoute?.();
    const pt = route?.pageType || 'page';
    const pageType = pt.charAt(0).toUpperCase() + pt.slice(1);

    let parentName = '';
    let navItemPosition = 1;

    if (link.classList?.contains('menu-list__link')) {
      const items = nav?.querySelectorAll('a.menu-list__link');
      if (items) navItemPosition = Array.from(items).indexOf(link) + 1;
    } else if (link.classList?.contains('mega-menu__link')) {
      const listItem = link.closest('.menu-list__list-item');
      const parentLink = listItem?.querySelector('.menu-list__link');
      if (parentLink) {
        const titleEl = parentLink.querySelector('.menu-list__link-title');
        parentName = (titleEl?.textContent || parentLink.textContent || '').trim();
      }
      const submenu = link.closest('.menu-list__submenu');
      const allLinks = submenu?.querySelectorAll('a.mega-menu__link');
      if (allLinks) navItemPosition = Array.from(allLinks).indexOf(link) + 1;
    }

    const titleEl = link.querySelector('.menu-list__link-title, .mega-menu__link-title');
    const navItemName = (titleEl?.textContent || link.textContent || '').trim();

    gtag('event', 'clickOnNavigationBar', {
      page_location: window.location.href,
      page_title: document.title || '',
      referrer: document.referrer || '',
      page_type: pageType,
      nav_item_position: navItemPosition,
      nav_item_name: navItemName,
      parent_name: parentName,
      clickURL: link.href || '',
    });
  }

  function attachToNav(nav) {
    let hoverOnNavFired = false;
    let expandedFiredFor = null;

    nav.addEventListener('pointerover', (e) => {
      if (!hoverOnNavFired && nav.contains(e.target)) {
        hoverOnNavFired = true;
        gtag('event', 'hoverOnNavigationBar', getPageParams());
      }
    });

    nav.addEventListener('pointerleave', (e) => {
      if (!nav.contains(e.relatedTarget)) {
        hoverOnNavFired = false;
        expandedFiredFor = null;
      }
    });

    nav.addEventListener('click', (e) => {
      const link = e.target?.closest?.('a.menu-list__link, a.mega-menu__link');
      if (link) handleClick(link, nav);
    });

    nav.querySelectorAll('.menu-list__link[aria-haspopup]').forEach((el) => {
      el.addEventListener('pointerenter', () => {
        if (el !== expandedFiredFor) {
          expandedFiredFor = el;
          gtag('event', 'SysNavigationBarExpanded', getPageParams());
        }
      });
    });
  }

  function init() {
    const navs = document.querySelectorAll('nav[header-menu], [header-menu]');
    navs.forEach(attachToNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
